import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "data-testId": "splash-tracking-pixel-setup",
  class: "tw-pb-8"
}
const _hoisted_2 = {
  key: 0,
  class: "tw-mx-auto tw-mb-6 tw-w-auto tw-max-w-[1000px] tw-px-2"
}
const _hoisted_3 = { class: "tw-mx-auto tw-grid tw-w-auto tw-max-w-[1000px] tw-grid-cols-1 tw-gap-y-10" }
const _hoisted_4 = { class: "tw-w-full tw-px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrackingConsentNotice = _resolveComponent("TrackingConsentNotice")!
  const _component_CodeEditorWrapper = _resolveComponent("CodeEditorWrapper")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Tracking Pixel Snippet",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.showConsentNotice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_TrackingConsentNotice, { showTagRule: false })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createBlock(_component_CodeEditorWrapper, _mergeProps({
              key: _ctx.isFetchingScript ? 'abc' : 'xyz'
            }, _ctx.state, {
              codeAreaKey: _ctx.codeAreaKey,
              characterLimit: 4096,
              onSave: _cache[0] || (_cache[0] = ({ onSuccess, onFailure, doc }) => _ctx.handleSave(onSuccess, onFailure, doc)),
              onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditing = true)),
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEditing = false))
            }), null, 16, ["codeAreaKey"]))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}